import { TManageColorProperties } from './manage-color.types';

export function manageColor({ color, theme }: TManageColorProperties): string {
    if (!color) {
        return theme.color.indigo;
    }

    return theme.color[color];
}
